import React, { useEffect, useState } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'

import { getEventData } from '../../logic/requests/events.js'

import MenuItemRound from '../molecules/Results/MenuItemRound'
import ResultsData from '../organisms/Results/ResultsData'
import Sponsors from '../molecules/Sponsors/Sponsors.js'

import { StyledResultPage } from '../atoms/Results/StyledResultPage'
import { StyledCompetitionMenu } from '../atoms/Results/StyledCompetitionMenu'
import { StyledResultsContent } from '../atoms/Results/StyledResultsContent'
import { StyledResultPageHeader } from '../atoms/Results/StyledResultPageHeader'
import { StyledText } from '../atoms/Text/StyledText'
import { getCompetitionsForEvent } from '../../logic/requests/competitions.js'

const Results = () => {
    const { code, competitionid, roundid, categoryid } = useParams()
    const roundNo = parseInt(roundid)
    const navigate = useNavigate();

    const [competitions, setCompetitions] = useState([]),
        [competition, setCompetition] = useState(null),
        [rounds, setRounds] = useState([]),
        [round, setRound] = useState(null),
        [roundCategory, setRoundCategory] = useState(null),
        [eventName, setEventName] = useState(),
        [eventId, setEventId] = useState()

    useEffect(() => {
        getEventData(code).then((ret) => {
            if (ret.type.id !== "online")
                navigate("/", { replace: true })
            setEventName(ret.name)
            setEventId(ret.id)
        })
        .catch(() => navigate("/", { replace: true }))
    }, [ code ])
    useEffect(() => {
        if (eventId) {
            getCompetitionsForEvent(eventId, {
                withRounds: true,
                withRoundsRoundCategories: true,
            })
                .then((ret) => {
                    ret.forEach((competition) =>
                        competition.rounds.forEach(
                            (round) =>
                                round.categories.length &&
                                round.categories.push({
                                    id: null,
                                    name: 'Open',
                                })
                        )
                    )
                    setCompetitions(ret)
                })
                .catch((err) => console.log('getCompetitionsForEvent', err))
        }
    }, [eventId])
    useEffect(() => {
        if (!(competitions && competitions.length)) return

        let round_count = 0
        competitions.forEach((competition) => {
            const len = competition.rounds.length
            if (len > round_count) round_count = len
        })

        let this_menu_fucking_sucks = []
        for (let i = 0; i < round_count; i++)
            this_menu_fucking_sucks.push({
                id: i + 1,
                competitions,
            })
        setRounds(this_menu_fucking_sucks)
    }, [competitions])
    useEffect(() => {
        if (!competitions) return

        const competition = competitions.find(
            (competition) => competition.id === competitionid
        )
        setCompetition(competition)
    }, [competitions, competitionid])
    useEffect(() => {
        if (!(competition && !isNaN(roundNo))) return

        const round = competition.rounds.find((round) => round.id === roundNo)
        setRound(round)
    }, [competition, roundNo])
    useEffect(() => {
        if (!round) return

        const round_category = round.categories.find(
            (category) => category.id === categoryid
        )
        setRoundCategory(round_category)
    }, [round, categoryid])

    return (
        <StyledResultPage>
            <StyledResultPageHeader>
                <StyledText hasdeclaredfontsize="36px" as="span">
                    <Link to={`/`}>
                        <>&#10229;</>
                    </Link>
                </StyledText>
                <StyledText
                    hasdeclaredfontsize="48px"
                    hasdeclaredtextalign="center"
                    hasdeclaredpadding="24px 0"
                    hasdeclaredfontcolor="#F9EC4B"
                    hasdeclaredfontweight="bold"
                    as="h2"
                >
                    {eventName}
                </StyledText>
            </StyledResultPageHeader>
            <StyledResultsContent>
                <StyledCompetitionMenu>
                    {rounds && rounds.length ? (
                        rounds.map((round) => (
                            <MenuItemRound
                                round={round}
                                count={rounds.length}
                                eventCode={code}
                            />
                        ))
                    ) : (
                        <></>
                    )}
                </StyledCompetitionMenu>
                {competitionid && roundid && competition ? (
                    <ResultsData
                        eventId={eventId}
                        competitionId={competitionid}
                        roundId={roundid}
                        category={roundCategory}
                        roundDisplay={
                            roundNo === competition.rounds.length
                                ? 'Finał'
                                : roundNo === competition.rounds.length - 1
                                ? 'Półfinał'
                                : roundNo
                        }
                    />
                ) : (
                    <></>
                )}
            </StyledResultsContent>
            <Sponsors />
        </StyledResultPage>
    )
}

export default Results
